export const extremity = (() => {
    const placeHolderText = 'No cyanosis, edema or crepitus'

    return placeHolderText
})